import React, { useState } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';

interface NavDropdownProps {
  title: string;
}

export const NavDropdownHover: React.FC<NavDropdownProps> = ({
  title,
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <NavDropdown
      title={title}
      menuVariant="dark"
      className="text-uppercase"
      show={isOpen}
      onMouseOver={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      {children}
    </NavDropdown>
  );
};
